import {
  ref,
  onMounted,
  onUnmounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";

import { inventoryLotsController } from "@/controllers/inventoryLots";

import { JSConn } from "@/utilities/js-conn";

import { ActiveNavMenuSetting } from "@/store/modules/session";

export default defineComponent({
  name: "inventoryLotShow",
  components: {
    LoadingAnimation,
  },
  props: {
    inventoryLotId: {
      type: String,
      required: true,
    },
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref(
      "Please wait while the inventory lot is loaded...",
    );

    onMounted(() => {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: props.inventoryLotId,
      };

      Promise.all([inventoryLotsController.needInventoryLot(jsConn)])
        .then(() => {
          $store.dispatch(
            "updateActiveNavMenu",
            ActiveNavMenuSetting.inventoryLot,
          );
        })

        .finally(() => {
          dataLoaded.value = true;
        });
    });

    onUnmounted(() => {
      $store.dispatch("updateActiveNavMenu", ActiveNavMenuSetting.main);
    });

    return {
      dataLoaded,
      loadingMessage,
    };
  },
});
